import React from "react";
import Hero from "../components/Hero";
import PillarsStrip from "../components/PillarsStrip";
import SummarySections from "../components/SummarySections";

const Home = () => {
  return (
    <main data-testid="home-page">
      <Hero />
      <PillarsStrip />
      <SummarySections />
    </main>
  );
};

export default Home;
